import { theme } from '@notino/react-styleguide'
import styled, { css } from 'styled-components'

// utils
import { CONTAINER_X_PADDING } from '../../styles/constants'

// styles
import { resetButtonStyles } from '../../styles/helpers'

/** Width of edge fade overlays; also used as focus scroll inset */
export const FADE_WIDTH_PX = 96

export const ElementsSliderWrapper = styled.div`
	position: relative;
	margin-left: -${CONTAINER_X_PADDING}px;
	margin-right: -${CONTAINER_X_PADDING}px;
`

export const ElementsSlider = styled.div<{
	$overflowX: 'auto' | 'scroll' | 'hidden'
	$hideScrollbar: boolean
	$hasEdgeOverlays: boolean
}>`
	scroll-behavior: smooth;
	overflow-x: ${({ $overflowX }) => $overflowX};

	${({ $hasEdgeOverlays }) =>
		$hasEdgeOverlays &&
		css`
			/* Keep focused chips clear of fade/arrow overlays when the browser auto-scrolls */
			scroll-padding-inline: ${FADE_WIDTH_PX}px;
		`}

	${({ $hideScrollbar }) =>
		$hideScrollbar &&
		css`
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none; /* IE and Edge */
			&::-webkit-scrollbar {
				display: none; /* Chrome, Safari and Opera */
			}
		`}
`

export const ElementsSliderContent = styled.div<{ $gap: string; $asList?: boolean }>`
	display: inline-flex;
	gap: ${({ $gap }) => $gap};
	padding: 2px 0;
	padding-left: ${CONTAINER_X_PADDING}px;
	padding-right: ${CONTAINER_X_PADDING}px;

	${({ $asList }) =>
		$asList &&
		css`
			list-style: none;
			margin: 0;
		`}
`

export const FadeLeft = styled.div`
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	z-index: 1;
	width: ${FADE_WIDTH_PX}px;
	background: linear-gradient(to left, transparent 0%, ${theme.color.background.primary} 80%, ${theme.color.background.primary} 100%);
	pointer-events: none;
`

export const FadeRight = styled.div`
	position: absolute;
	top: 0px;
	bottom: 0px;
	right: 0px;
	width: ${FADE_WIDTH_PX}px;
	z-index: 1;
	background: linear-gradient(to right, transparent 0%, ${theme.color.background.primary} 80%, ${theme.color.background.primary} 100%);
	pointer-events: none;
`

export const ScrollButton = styled.button`
	${resetButtonStyles};
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	background: transparent;
`

export const ScrollLeftButton = styled(ScrollButton)`
	left: ${CONTAINER_X_PADDING}px;
`

export const ScrollRightButton = styled(ScrollButton)`
	right: ${CONTAINER_X_PADDING}px;
`
